import { SMAA, EffectComposer, Bloom } from "@react-three/postprocessing";
import {  useFrame } from "@react-three/fiber";
import React, { useRef } from "react";

export function Effects(){

    const bloomref = useRef()

    let time = 0.0

    useFrame(() =>{
        time += 0.032
        //  bloomref.current.radius = Math.sin(time) * 0.5 + 0.5
         bloomref.current.intensity = (Math.sin(time) * 0.5 + 0.5) * 3.5

    })

     return(
        <EffectComposer disableNormalPass>
        <Bloom
          ref={bloomref}
          radius={0.65}
          luminanceThreshold={0.49}
          mipmapBlur
          luminanceSmoothing={0.45}
          intensity={3}
        />
        <SMAA />

      </EffectComposer>
     )
}